import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Page, PageBody, Spinner } from 'next/components/ui';

import {
  readOne as getExperience,
  selectExperience,
} from 'next/entities/experiences';
import { Loading } from './styled';

import Header from './Header';

export const SettingsPage = ({ id, loaded, onLoad }) => {
  useEffect(() => {
    onLoad?.(id);
  }, [id, onLoad]);

  if (!loaded) {
    return (
      <Loading>
        <Spinner aria-label="Loading" />
      </Loading>
    );
  }

  return (
    <Page>
      <Header id={id} />
      <PageBody>setting page</PageBody>
    </Page>
  );
};

SettingsPage.propTypes = {
  id: PropTypes.string,
  loaded: PropTypes.bool,
  onLoad: PropTypes.func,
};

const mapStateToProps = (
  state,
  {
    match: {
      params: { experienceId },
    },
  }
) => {
  const experience = selectExperience(state, experienceId);

  return {
    id: experienceId,
    loaded: Boolean(experience),
  };
};

const mapDispatchToProps = {
  onLoad: getExperience,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SettingsPage)
);
